import axios from 'axios';
export default (corpId, employeeId, creds) => {
  const promise = new Promise((resolve, reject) => {
    const payload = creds.payload;
    if (employeeId) {
      //patch
      axios
        .patch(`${process.env.VUE_APP_API_ADMIN_LOCATION}employees/${employeeId}`, payload)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    } else {
      //add
      payload.organization_id = corpId;
      payload.active = true;
      axios
        .post(`${process.env.VUE_APP_API_ADMIN_LOCATION}employees`, payload)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    }
  });

  return promise;
};
